export default __webpack_public_path__ + "static/media/light_badge.e16d3c80.svg";